import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import Footer from "./components/Footer";
import CareersPage from "./pages/CareersPage";
import ContactPage from "./pages/ContactPage";
import CandidatePage from "./pages/CandidatePage";
import CompanyPage from "./pages/CompanyPage";
import { ScrollToTop } from "./components/ui";
import ServicePage from "./pages/ServicePage";
import NewsBlogsPage from "./pages/NewsBlogsPage";
import BlogPage1 from "./pages/BlogPage1";
import BlogPage2 from "./pages/BlogPage2";
import BlogPage3 from "./pages/BlogPage3";
import BlogPage4 from "./pages/BlogPage4";
import CandidateProfilePage from "./pages/CandidateProfilePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import StartupWorkforcePage from "./pages/StartupWorkforcePage";



function App() {
  return (
    <Router>
      <div className="flex min-h-screen flex-col bg-white font-sans text-ink">
        <ScrollToTop />
        <Navbar />
        <main className="flex-1"> {/* dark page headers run behind the fixed navbar */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-and-conditions" element={<TermsPage />} />
            <Route path="/candidates" element={<CandidatePage />} />
            <Route path="/company" element={<CompanyPage />} />
            <Route path="/services" element={<ServicePage />} />
            <Route path="/startup-workforce" element={<StartupWorkforcePage />} />
            <Route path="/news-blogs" element={<NewsBlogsPage/>}/>
            <Route path="/blog/role-of-semiconductors-in-modern-technology" element={<BlogPage1/>}/>
            <Route path="/blog/custom-chip-design-tailored-solutions-automation" element={<BlogPage2/>}/>
            <Route path="/blog/semiconductor-automation-smart-chips-transform-business" element={<BlogPage3/>}/>
            <Route path="/blog/semiconductor-trends-2025-and-beyond" element={<BlogPage4/>}/>
            {/* Legacy blog URLs — redirect to new keyword slugs for any existing bookmarks/shares */}
            <Route path="/blog1" element={<Navigate to="/blog/role-of-semiconductors-in-modern-technology" replace />} />
            <Route path="/blog2" element={<Navigate to="/blog/custom-chip-design-tailored-solutions-automation" replace />} />
            <Route path="/blog3" element={<Navigate to="/blog/semiconductor-automation-smart-chips-transform-business" replace />} />
            <Route path="/blog4" element={<Navigate to="/blog/semiconductor-trends-2025-and-beyond" replace />} />
            <Route path="/candidateprofile" element={<CandidateProfilePage/>}/>


          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
